<template>
  <div class="homeBox" ref="homBox">
    <!--    banner     -->
    <div class="banner">
      <img src="../../public/img/banner.jpg" alt="">
      <div class="softScript">
        <div class="TipText">
          <div class="title" @click="clTitle()">自动化行业自己的<br/>项目管理软件</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            帮助自动化公司的项目管理实现数字化、可视化<br/>
            把控项目风险，控制项目成本，降低财务风险，提高效率
          </div>
          <div class="start">
            <!--http://www.ty6076020.com/apm-->
            <a href="javascript:;" onclick="window.open('http://www.teamrobotics.net/project')">
              开始吧
              <img src="../../public/img/right.png" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>

    <!--革新项目管理-->
    <div class="ProjectManageModule">
      <div class="w1200">
        <div class="TipText">
          <div class="title">革新项目管理，打造智慧企业</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            满足不同自动化公司需求，专为自动化企业量身
            打造的生态管理系统
          </div>
        </div>
        <!--八大核心体系-->
        <div class="CoreSystem">
          <div class="tip">8大核心体系</div>
          <div>
            <ul class="clearfix">
              <li>
                <a href="javascript:;">
                  <img src="../../public/img/icon4.png" alt="">
                  <p>项目实施</p>
                  <div>我的项目，项目计划，项目文档,
                    项目问题，项目采购</div>
                </a>
              </li>
              <li>
                <a href="javascript:;">
                  <img src="../../public/img/icon3.png" alt="">
                  <p>销售业务</p>
                  <div>销售项目，拜访客户，我的报价,
                    报价参考，我的合同，我的客户</div>
                </a>
              </li>
              <li>
                <a href="javascript:;">
                  <img src="../../public/img/icon2.png" alt="">
                  <p>企业面板</p>
                  <div>企业总览，企业项目，企业客户,
                    销售合同，销售报价，计划收款,
                    计划付款，工作计划，工作汇报</div>
                </a>
              </li>
              <li>
                <a href="javascript:;">
                  <img src="../../public/img/icon1.png" alt="">
                  <p>我在企业</p>
                  <div>工作日程，我的审批，工作汇报,
                    我的任务，发起申请，个人信息,
                    消息通知</div>
                </a>
              </li>
            </ul>
            <ul class="clearfix">
              <li>
                <a href="javascript:;">
                  <img src="../../public/img/icon8.png" alt="">
                  <p>微信应用</p>
                  <div>应用管理，自定义菜单</div>
                </a>
              </li>
              <li>
                <a href="javascript:;">
                  <img src="../../public/img/icon7.png" alt="">
                  <p>企业设置</p>
                  <div>基本信息，机构配置，标签管理,
                    成员管理，角色管理，审批流程,
                    消息通知</div>
                </a>
              </li>
              <li>
                <a href="javascript:;">
                  <img src="../../public/img/icon6.png" alt="">
                  <p>企业仓库</p>
                  <div>待入库订单，入库单，领料单,
                    库存</div>
                </a>
              </li>
              <li>
                <a href="javascript:;">
                  <img src="../../public/img/icon5.png" alt="">
                  <p>企业采购</p>
                  <div>我的询价单，采购订单，采购发票,
                    供应商</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--基于不同场景解决各种问题-->
    <div class="SolveQuestion">
      <div class="w1200">
        <div class="TipText">
          <div class="title">基于不同场景解决各种问题</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            现在，无论你处于管理、设计、采购还是销售部门，都可以借助
            自动化管家来帮助团队进行项目的管控，增强管理能力，提升管
            理效率
          </div>
        </div>
        <!--销售-->
        <div class="clearfix Sales">
          <div class="l">
            <img src="../../public/img/mg1.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/icon13.png" alt="">
            </div>
            <div class="tip">
              销售状态可控，销售结果
              数据化
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>立项申请</div>
                    <p>建立项目编号，便于后期统计项目成本</p>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>拜访日志</div>
                    <p>记录从一开始接触到签单过程中的个人、事件、
                      日志、报价、合同及各种细节</p>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>在线报价</div>
                    <p>标准化报价，建立报价审批流程，减少报价不合规
                      的风险</p>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>合同管理</div>
                    <p>保存合同，建立收款日期管理，提示销售及时催款</p>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!--进度-->
        <div class="clearfix Progress">
          <div class="l">
            <img src="../../public/img/mg2.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/icon14.png" alt="">
            </div>
            <div class="tip">
              项目进度实时掌握，
              进程管理一目了然
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>项目计划</div>
                    <p>制定与修改项目计划，并发布通知到执行人</p>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>项目文档</div>
                    <p>图纸归档，程序归档</p>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>项目问题点</div>
                    <p>风险点及项目点可视化，建立问题派发及任务
                      反馈机制</p>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>项目采购</div>
                    <p>工程师BOM单个或者批量上传，便于查询物料
                      流转状态</p>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--采购-->
        <div class="clearfix Purchase">
          <div class="l">
            <img src="../../public/img/mg3.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/icon15.png" alt="">
            </div>
            <div class="tip">
              简化运营，打造高效、合规和透明的采购流程
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>革新采购流程</div>
                    <p>设计上传BOM、项目经理审批、采购询价比价、
                      采购合同审批及管理、付款申请、发票管理、
                      供应商建立及审批，避免漏采购、误采购、丢发票</p>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>优化采购需求</div>
                    <p>多项目合并采购，自动分类将元器件分配给不同
                      的采购，询价功能状态提醒，便于采购跟踪订单</p>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--领料-->
        <div class="clearfix Progress GetMetarial">
          <div class="l">
            <img src="../../public/img/mg4.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/icon16.png" alt="">
            </div>
            <div class="tip">
              领料流程，
              统一有序
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>出入有序</div>
                    <p>实时查看物料库存，出入库记录明细</p>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>减少不规范</div>
                    <p>快速追溯生产领料和用料批次，锁定问题
                      源头改进领料过程</p>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>及时了解</div>
                    <p>实时展示库存波动和库存水位，提升库存
                      利用率和周转效率</p>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--价值与亮点-->
    <div class="SolveQuestion ValueHighlights">
      <div class="w1200">
        <div class="TipText">
          <div class="title">价值亮点</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            利用预测算法和机器学习，评估未来结果出现的几率，
            确保企业朝着正确的方向发展
          </div>
        </div>
        <!--数据分析-->
        <div class="clearfix DataAnalysis">
          <div class="l">
            <img src="../../public/img/mg5.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/icon17.png" alt="">
            </div>
            <div class="tip">
              数据分析
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>项目采购成本预测</div>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>项目成本统计，包括「人工投入、
                      采购支出、报销金额」等</div>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>项目采购支出汇总</div>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>项目报销分析</div>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>员工KPI考核</div>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>应收应付资金预测</div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--信息安全-->
        <div class="clearfix Progress InfoSafety">
          <div class="l">
            <img src="../../public/img/mg6.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/icon18.png" alt="">
            </div>
            <div class="tip">
              多重技术保障，
              稳定不丢信息
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>数据安全</div>
                    <p>所有程序和数据都纳入腾讯云安防体系，拥有高
                      级别的安全防护与数据监控措施确保系统的稳定
                      性与数据的安全性，保证数据不丢失不泄露</p>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div><span class="triangle-right"></span>隐私安全</div>
                    <p>所有隐私信息都经过加密处理，防止任何人包括
                      公司员工不当获取信息，降低人为导致的数据被
                      滥用的可能性</p>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--与众不同-->
    <div class="ProjectManageModule different">
      <div class="w1200">
        <div class="TipText">
          <div class="title">是什么让我们与众不同</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            我们只做一件事情，产品只有一个定位
          </div>
        </div>
        <div class="CoreSystem">
          <div>
            <ul class="clearfix">
              <li>
                <a href="javascript:;">
                  <img src="../../public/img/icon9.png" alt="">
                  <p>项目统一跟踪，实时监管</p>
                  <div>项目全部管理聚合显示项目进展，权限
                    内的项目全局掌握</div>
                </a>
              </li>
              <li>
                <a href="javascript:;">
                  <img src="../../public/img/icon10.png" alt="">
                  <p>任务逐级分解，掌控进度</p>
                  <div>任务执行自动化，任务协同执行，有人
                    抓/有人管/有人落实</div>
                </a>
              </li>
              <li>
                <a href="javascript:;">
                  <img src="../../public/img/icon11.png" alt="">
                  <p>全面控制成本、规避风险</p>
                  <div>工作量汇总统计，从多个维度，汇总和
                    统计实际工作量</div>
                </a>
              </li>
              <li>
                <a href="javascript:;">
                  <img src="../../public/img/icon12.png" alt="">
                  <p>量化工作，精确评估</p>
                  <div>项目预算和费用设定项目预算，汇总每
                    一笔费用并跟踪</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--服务行业-->
    <div class="different ServiceTrade">
      <div class="w1200 w1000">
        <div class="TipText">
          <div class="title">服务行业</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            持续深挖自动化项目型企业运营管理痛点
          </div>
        </div>
        <!--轮播  PC端-->
        <SwiperPc></SwiperPc>
        <!--轮播  PC端-->
        <SwiperMobile></SwiperMobile>
      </div>
    </div>
    <!--提高效率，提高竞争力-->
    <div class="Increase">
      <div class="w1200">
        <div class="TipText">
          <div class="title">提高效率，提高竞争力</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            让每个自动化企业都享受智慧服务与数据
            带来的改变
            <div class="bottomStart"><a href="javascript:;" onclick="window.open('http://www.teamrobotics.net/project')">开始吧<img src="../../public/img/right.png" alt=""></a></div>
          </div>
        </div>
      </div>
    </div>
    <div class="Shading"></div>
    <div class="Shading Shading2"></div>
    <div class="Shading Shading3"></div>
    <!--导航  pc+mobile-->
    <Nav></Nav>
    <!--底部-->
    <Foot></Foot>
    <!--返回头部-->
    <GoTop></GoTop>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Nav from '@/components/Nav.vue'
import GoTop from '@/components/GoTop.vue'
import Foot from '@/components/Foot.vue'
import SwiperPc from '@/components/SwiperPc.vue'
import SwiperMobile from '@/components/SwiperMobile.vue'

export default {
  name: 'home',
  data(){
    return {
      list:[]
    }
  },
  components: {
    Nav,
    GoTop,
    Foot,
    SwiperPc,
    SwiperMobile
  },
  computed:{

  },
  methods:{
    clTitle(){
      this.$http.get('/GetUserInfo').then((res) => {
        console.log(res)
      }).catch((err)=>{

      })
    }
  },
  mounted(){
    // this.$http.get('/user/UserInfo').then((res) => {
    //   console.log(res)
    // }).catch((err)=>{
    //
    // })
  },

  activated(){

  },
  created(){

  }
}
</script>
<style>
  .homeBox {
    position: fixed;
    width: 100%;
    height: 100%;
    top:0;
    left:0;
    bottom:0;
    right:0;
    overflow: auto;
  }
</style>
